export default __webpack_public_path__ + "static/media/users-create.3684a053.png";